// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2FsCG","insightsList":"newBusinessInsightsMenu_insightsList__14cjC","active":"newBusinessInsightsMenu_active__HjHsj"};